import {
  DataSet,
  pattern,
  RegExpMatcher,
  TextCensor,
  englishDataset,
  englishRecommendedTransformers,
} from 'obscenity';
import words from 'profane-words';

let __basejump_curseWordsDataset: DataSet | null = null;

const getDataset = () => {
  if (!__basejump_curseWordsDataset) {
    __basejump_curseWordsDataset = new DataSet().addAll(englishDataset);
    words.forEach((w: string) => {
      if (!w.includes("+")) {
        __basejump_curseWordsDataset.addPhrase((phrase) =>
          phrase
            .setMetadata({ originalWord: w })
            .addPattern(pattern`${w}`)
        )
      }
    });
  }
  return __basejump_curseWordsDataset;
};

const profanityMatcher = new RegExpMatcher({
  ...getDataset().build(),
  ...englishRecommendedTransformers,
});

export default function checkProfanity(text) {
  // Check direct match first
  if (words.some((w) => text.includes(w))) {
    return true;
  }
  return profanityMatcher.hasMatch(text);
}
